import React, { Component } from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";

// Inline-Edit einer Meta-Zelle über denselben PUT /api/metaData wie das
// MitarbeiterForm; leerer Wert löscht serverseitig.
class EditableMetaCell extends Component {
  constructor(props) {
    super(props);
    this.state = { editing: false, draft: "", saving: false };
  }

  // Index-keyed Zeilen können bei Sort/Refresh die Instanz einer anderen
  // Zeile zuordnen — dann darf der offene Draft nicht mitwandern
  static getDerivedStateFromProps(props, state) {
    if (state.entityId !== undefined && state.entityId !== props.entityId) {
      return { editing: false, draft: "", entityId: props.entityId };
    }
    return null;
  }

  startEditing = () => {
    this.setState({ editing: true, draft: this.props.value ?? "" });
  };

  cancelEditing = () => {
    this.setState({ editing: false });
  };

  onChange = (e) => {
    this.setState({ draft: e.target.value });
  };

  onKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      this.save();
    } else if (e.key === "Escape") {
      this.cancelEditing();
    }
  };

  onBlur = () => {
    if (this.state.saving) return;
    this.cancelEditing();
  };

  save = async () => {
    if (this.state.saving) return;
    // entityId/draft vor dem await capturen: remappt die Tabelle die Instanz
    // während des PUTs auf eine andere Zeile, bleibt das Routing trotzdem korrekt
    const { entityId, metaKey } = this.props;
    const value = this.state.draft;
    this.setState({ saving: true });
    try {
      const res = await fetch(global.api_url + "metaData", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: global.auth.authToken.token,
        },
        body: JSON.stringify({
          entity: "mitarbeiter",
          entityId,
          values: { [metaKey]: value },
        }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(
          data.message || "Meta-Wert konnte nicht gespeichert werden.",
        );
      }
      this.props.onSaved(entityId, value);
      this.setState({ editing: false, saving: false });
    } catch (err) {
      toast.error(err.message);
      this.setState({ editing: false, saving: false });
    }
  };

  render() {
    // Firmenspezifische Felder nur editierbar, wenn die Firma der Zeile das
    // Feld auch hat (globale Felder: fieldFirmenId null → immer editierbar)
    const editable =
      this.props.fieldFirmenId == null ||
      this.props.fieldFirmenId === this.props.rowFirmenId;
    if (!editable) {
      return <span>{this.props.value ?? ""}</span>;
    }
    if (this.state.editing) {
      return (
        <input
          className="meta-inline-edit"
          type="text"
          maxLength={500}
          autoFocus
          value={this.state.draft}
          disabled={this.state.saving}
          onChange={this.onChange}
          onKeyDown={this.onKeyDown}
          onBlur={this.onBlur}
        />
      );
    }
    return (
      <span
        className="meta-editable-cell"
        title="Zum Bearbeiten klicken"
        onClick={this.startEditing}
      >
        {this.props.value ?? ""}
      </span>
    );
  }
}

EditableMetaCell.propTypes = {
  value: PropTypes.string,
  entityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  rowFirmenId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fieldFirmenId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  metaKey: PropTypes.string.isRequired,
  onSaved: PropTypes.func.isRequired,
};

export default EditableMetaCell;
